import React from "react";
import {
  InfoOutlined,
  Inventory2Outlined,
  ManageAccountsOutlined,
  DirectionsCarFilledOutlined,
  AccessTime,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useSendOutDetailContext } from "contexts/SendOutDetailContext";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";
import { localizeDateTimeShort } from "utils/dateFormats";

const SendOutBasicDetail = () => {
  const { isCustomer, isVendor, isContractor, isDriver } = useAuth();
  const { sendOutDetail, loadingSendOut } = useSendOutDetailContext();

  return !loadingSendOut ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="Send Out ID"
            subtitle={sendOutDetail?.sendOutId || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <ManageAccountsOutlined color="primary" />}
            title={
              sendOutDetail?.responsibleUser
                ? "Delivered By"
                : "Assigned Driver"
            }
            subtitle={
              sendOutDetail?.responsibleUser ? (
                sendOutDetail.responsibleUser.name || "N/A"
              ) : sendOutDetail?.driverId ? (
                typeof sendOutDetail.driverId === "object" ? (
                  isCustomer || isVendor || isContractor || isDriver ? (
                    `${sendOutDetail.driverId.name || ""} (${
                      sendOutDetail.driverId.driverId || ""
                    })`
                  ) : (
                    <OpenInNewTab
                      label={`${sendOutDetail.driverId.name || ""} (${
                        sendOutDetail.driverId.driverId || ""
                      })`}
                      link={`/app/crm/driver/${sendOutDetail.driverId._id}/detail`}
                    />
                  )
                ) : (
                  sendOutDetail.driverId || "N/A"
                )
              ) : (
                "N/A"
              )
            }
          />
        </Grid>
        {!sendOutDetail?.responsibleUser && sendOutDetail?.vehicle_id && (
          <Grid item xs={3}>
            <InformationTile
              icon={() => <DirectionsCarFilledOutlined color="primary" />}
              title="Assigned Vehicle"
              subtitle={
                sendOutDetail?.vehicle_id &&
                typeof sendOutDetail.vehicle_id === "object" ? (
                  isCustomer || isVendor || isContractor || isDriver ? (
                    `${sendOutDetail.vehicle_id.vehicle_id || ""} (${
                      sendOutDetail.vehicle_id.registration_number || ""
                    })`
                  ) : (
                    <OpenInNewTab
                      label={`${sendOutDetail.vehicle_id.vehicle_id || ""} (${
                        sendOutDetail.vehicle_id.registration_number || ""
                      })`}
                      link={`/app/crm/vehicle/${sendOutDetail.vehicle_id._id}/detail`}
                    />
                  )
                ) : (
                  sendOutDetail?.vehicle_id || "N/A"
                )
              }
            />
          </Grid>
        )}
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={sendOutDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Created Time"
            subtitle={localizeDateTimeShort(sendOutDetail?.createdAt)}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Is Active ?"
          >
            <Status isActive={sendOutDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default SendOutBasicDetail;
